/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseGroupingTypeDto } from '../../models/response-grouping-type-dto';

export interface GetAllGroupingTypes$Params {
}

export function getAllGroupingTypes(http: HttpClient, rootUrl: string, params?: GetAllGroupingTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseGroupingTypeDto>> {
  const rb = new RequestBuilder(rootUrl, getAllGroupingTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseGroupingTypeDto>;
    })
  );
}

getAllGroupingTypes.PATH = '/grouping/types';
